// @flow
import {connect} from 'react-redux'
import NavSide from '../components/NavSide'
import {bindActionCreators} from 'redux'
import * as authenticateActions from 'modules/Authenticate/actions'

import type {MapStateToProps, MapDispatchToProps} from 'react-redux'
import type {State, Action} from 'modules/Common/types'

export type OwnProps = {};

export type StateProps = {};

export type DispatchProps = {
  logout: $PropertyType<typeof authenticateActions, 'logout'>
};

const mapStateToProps: MapStateToProps<State, OwnProps, StateProps> = (state: State) => {
  return {}
}

const mapDispatchToProps: MapDispatchToProps<Action<*>, OwnProps, DispatchProps> = dispatch => {
  return bindActionCreators(
    {
      logout: authenticateActions.logout
    },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(NavSide)
